<div class="steps" role="group" [attr.aria-label]="'Paso ' + step() + ' de 2'">
  <span class="steps-count">Paso {{ step() }} de 2</span>
  <div class="steps-bar" aria-hidden="true">
    <span class="steps-seg is-done"></span>
    <span class="steps-seg" [class.is-done]="step() === 2"></span>
  </div>
</div>

@if (step() === 1) {
<h1 class="auth-title">Crea tu cuenta</h1>
<p class="auth-lead">Empecemos por tu negocio. Son dos pasos y menos de un minuto.</p>
} @else {
<h1 class="auth-title">Ahora, tus datos</h1>
<p class="auth-lead">
  @if (isGoogleSignup) {
  Tomamos tu nombre y correo de Google. Solo falta tu teléfono.
  } @else {
  Con tu correo y contraseña entrarás a {{ registerForm.get('businessName')?.value || 'tu negocio' }}.
  }
</p>
}

@if (step() === 1 && !isGoogleSignup) {
<button type="button" class="btn-google" (click)="signInWithGoogle()">
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <path
      d="M18.7511 10.1944C18.7511 9.47495 18.6915 8.94995 18.5626 8.40552H10.1797V11.6527H15.1003C15.0011 12.4597 14.4654 13.675 13.2749 14.4916L13.2582 14.6003L15.9087 16.6126L16.0924 16.6305C17.7788 15.1041 18.7511 12.8583 18.7511 10.1944Z"
      fill="#4285F4" />
    <path
      d="M10.1788 18.75C12.5895 18.75 14.6133 17.9722 16.0915 16.6305L13.274 14.4916C12.5201 15.0068 11.5081 15.3666 10.1788 15.3666C7.81773 15.3666 5.81379 13.8402 5.09944 11.7305L4.99473 11.7392L2.23868 13.8295L2.20264 13.9277C3.67087 16.786 6.68674 18.75 10.1788 18.75Z"
      fill="#34A853" />
    <path
      d="M5.10014 11.7305C4.91165 11.186 4.80257 10.6027 4.80257 9.99992C4.80257 9.3971 4.91165 8.81379 5.09022 8.26935L5.08523 8.1534L2.29464 6.02954L2.20333 6.0721C1.5982 7.25823 1.25098 8.5902 1.25098 9.99992C1.25098 11.4096 1.5982 12.7415 2.20333 13.9277L5.10014 11.7305Z"
      fill="#FBBC05" />
    <path
      d="M10.1789 4.63331C11.8554 4.63331 12.9864 5.34303 13.6312 5.93612L16.1511 3.525C14.6035 2.11528 12.5895 1.25 10.1789 1.25C6.68676 1.25 3.67088 3.21387 2.20264 6.07218L5.08953 8.26943C5.81381 6.15972 7.81776 4.63331 10.1789 4.63331Z"
      fill="#EB4335" />
  </svg>
  Registrarme con Google
</button>

<div class="divider">o con tu correo</div>
} @else {
<div class="spacer"></div>
}

<form [formGroup]="registerForm" (ngSubmit)="onFormSubmit()" novalidate>
  @if (step() === 1) {
  <div class="fields">
    <div>
      <label class="field-label" for="businessName">Nombre de tu negocio</label>
      <input type="text" id="businessName" name="businessName" class="input" formControlName="businessName"
        autocomplete="organization" placeholder="Ej: Barbería Elite" [class.is-invalid]="showError('businessName')"
        [attr.aria-invalid]="showError('businessName')"
        [attr.aria-describedby]="showError('businessName') ? 'businessName-error' : null" />
      @if (showError('businessName')) {
      <p class="field-error" id="businessName-error">Escribe el nombre de tu negocio.</p>
      }
    </div>

    <div>
      <label class="field-label" for="businessType">¿A qué se dedica?</label>
      <div class="select-wrap">
        <select id="businessType" name="businessType" class="input" formControlName="businessTypeId"
          (change)="onOptionChange()" [class.is-invalid]="showError('businessTypeId')"
          [attr.aria-invalid]="showError('businessTypeId')"
          [attr.aria-describedby]="showError('businessTypeId') ? 'businessType-error' : null">
          <option value="" disabled>Elige el tipo de negocio</option>
          @for (type of businessType$(); track type.businessTypeId) {
          <option [value]="type.businessTypeId">{{ type.name }}</option>
          }
        </select>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path d="M5 7.5l5 5 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </div>
      @if (showError('businessTypeId')) {
      <p class="field-error" id="businessType-error">Elige el tipo de negocio. Si no aparece, elige «Otro».</p>
      }
    </div>
  </div>

  <div class="actions">
    <button type="submit" class="btn-primary">Continuar</button>
  </div>
  } @else {
  <div class="fields">
    <div>
      <label class="field-label" for="fullName">Tu nombre completo</label>
      <input type="text" id="fullName" name="fullName" class="input" formControlName="fullName" autocomplete="name"
        placeholder="Ej: María López" [class.is-invalid]="showError('fullName')"
        [attr.aria-invalid]="showError('fullName')"
        [attr.aria-describedby]="showError('fullName') ? 'fullName-error' : null" />
      @if (showError('fullName')) {
      <p class="field-error" id="fullName-error">Escribe tu nombre, con al menos 3 letras.</p>
      }
    </div>

    <div>
      <label class="field-label" for="registerEmail">Correo electrónico</label>
      <input type="email" id="registerEmail" name="registerEmail" class="input" formControlName="email"
        autocomplete="email" inputmode="email" placeholder="nombre@correo.com"
        [class.is-invalid]="showError('email')" [attr.aria-invalid]="showError('email')"
        [attr.aria-describedby]="showError('email') ? 'email-error' : null" />
      @if (showError('email')) {
      <p class="field-error" id="email-error">
        {{ registerForm.get('email')?.hasError('required') ? 'Escribe tu correo.' : 'Revisa el correo, debe verse como nombre@correo.com.' }}
      </p>
      }
    </div>

    <div class="phone-field">
      <label class="field-label" for="phone">Teléfono</label>
      <app-phone-input formControlName="phone" id="phone"></app-phone-input>
      @if (showError('phone') && !registerForm.get('phone')?.value) {
      <p class="field-error">Escribe tu número de teléfono.</p>
      }
    </div>

    @if (!isGoogleSignup) {
    <div>
      <label class="field-label" for="password">Crea una contraseña</label>
      <div class="input-wrap">
        <input id="password" name="password" class="input" formControlName="password" autocomplete="new-password"
          [type]="showPassword ? 'text' : 'password'" [class.is-invalid]="showError('password')"
          [attr.aria-invalid]="showError('password')" aria-describedby="password-rules" />
        <button type="button" class="toggle-pass" (click)="togglePasswordVisibility()"
          [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
          [attr.aria-pressed]="showPassword">
          @if (showPassword) {
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <path d="M3 3l14 14M8.2 8.3a2.5 2.5 0 0 0 3.5 3.5M6 5.6C4.3 6.7 3.1 8.3 2.5 10c1.2 3.3 4.2 5.5 7.5 5.5 1.4 0 2.8-.4 4-1.1M9 4.6c.3 0 .7-.1 1-.1 3.3 0 6.3 2.2 7.5 5.5-.4 1-.9 1.9-1.6 2.7"
              stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          </svg>
          } @else {
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <path d="M2.5 10c1.2-3.3 4.2-5.5 7.5-5.5s6.3 2.2 7.5 5.5c-1.2 3.3-4.2 5.5-7.5 5.5S3.7 13.3 2.5 10Z"
              stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
            <circle cx="10" cy="10" r="2.5" stroke="currentColor" stroke-width="1.5" />
          </svg>
          }
        </button>
      </div>
      <ul class="rules" id="password-rules" [class.is-checking]="showError('password')">
        @for (rule of passwordRules; track rule.label) {
        <li [class.is-met]="rule.test(passwordValue())">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            @if (rule.test(passwordValue())) {
            <path d="M3.5 8.5l3 3 6-7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
              stroke-linejoin="round" />
            } @else {
            <circle cx="8" cy="8" r="2.5" fill="currentColor" />
            }
          </svg>
          {{ rule.label }}
          <span class="sr-only">{{ rule.test(passwordValue()) ? '(cumplido)' : '(pendiente)' }}</span>
        </li>
        }
      </ul>
    </div>
    }
  </div>

  <p class="terms">
    Al crear tu cuenta aceptas los
    <a href="https://citalinkpro.com/terms-of-service" target="_blank" rel="noopener" class="link">Términos y
      condiciones</a>.
  </p>

  <div class="actions">
    <button type="button" class="btn-secondary" (click)="goToStep(1)">Atrás</button>
    <button type="submit" class="btn-primary" [disabled]="isSaving">
      @if (isSaving) {
      <span class="spinner" aria-hidden="true"></span>
      Creando tu cuenta…
      } @else {
      Crear cuenta gratis
      }
    </button>
  </div>
  }
</form>

<p class="switch-line">
  ¿Ya tienes cuenta?
  <a routerLink="/auth/signin" class="link">Inicia sesión</a>
</p>
